import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

function Unauthorized() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <h1 className="text-4xl font-bold mb-4 text-red-500">Access Denied</h1>
      <p className="text-gray-600 mb-6">
        Your account is inactive or not authorized to access this page.
      </p>
      <Button type="primary" onClick={() => navigate("/login")}>
        Go to Login
      </Button>
    </div>
  );
}

export default Unauthorized;
